import { useContext, useEffect, useState } from "react";

import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";
import { canShowMenu } from "../../helpers/menuAccess";
import { ratingSystemText } from "../../helpers/systemMessageText";

// Nota por ratingId, compartilhada entre os avisos da conversa: cada nota é
// buscada uma vez só, mesmo com a lista re-renderizando.
const ratingCache = new Map();

const fetchRating = ratingId => {
  if (!ratingCache.has(ratingId)) {
    ratingCache.set(
      ratingId,
      api
        .get(`/ticket-ratings/${ratingId}`)
        .then(({ data }) =>
          data && data.rate !== null && data.rate !== undefined
            ? { rate: data.rate, max: data.max }
            : null
        )
        .catch(() => null)
    );
  }
  return ratingCache.get(ratingId);
};

const parseDataJson = message => {
  try {
    return JSON.parse(message?.dataJson || "{}") || {};
  } catch (e) {
    return {};
  }
};

// Aviso "Cliente avaliou o atendimento" no chat. O atendente sem acesso às
// Avaliações (menu "avaliacoes" no perfil; admin sempre tem) vê só que houve
// avaliação, sem a nota — a mensagem gravada também não carrega a nota.
const RatingSystemText = ({ message }) => {
  const { user, menus } = useContext(AuthContext);
  const allowed = canShowMenu(user, menus, "avaliacoes");
  const dataJson = parseDataJson(message);
  const ratingId = dataJson.ratingId;
  const legacyRate =
    dataJson.rate !== undefined && dataJson.rate !== null
      ? { rate: dataJson.rate, max: 10 }
      : null;

  const [rating, setRating] = useState(null);

  useEffect(() => {
    if (!allowed || !ratingId) return undefined;
    let active = true;
    fetchRating(ratingId).then(result => {
      if (active) setRating(result);
    });
    return () => {
      active = false;
    };
  }, [allowed, ratingId]);

  if (!allowed) return ratingSystemText(message?.body, null);
  return ratingSystemText(message?.body, rating || legacyRate);
};

export default RatingSystemText;
